class CTRecentlyViewed {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('[data-ct-recently-viewed-grid]');
    this.currentHandle = section.dataset.currentHandle;
    this.limit = Number(section.dataset.limit || 4);
    this.moneyFormat = section.dataset.moneyFormat || '${{amount}}';
    this.storageKey = 'ct-recently-viewed-products';

    if (!this.grid) return;

    this.init();
  }

 async init() {
  const storedHandles = this.getStoredHandles();

  let handlesToDisplay = storedHandles;

  /*
   * Trên Product Page:
   * Không hiển thị lại chính sản phẩm khách đang xem.
   *
   * Trên Collection Page:
   * currentHandle rỗng, nên hiển thị toàn bộ lịch sử đã lưu.
   */
  if (this.currentHandle) {
    handlesToDisplay = storedHandles.filter(
      (handle) => handle !== this.currentHandle
    );

    this.saveCurrentProduct(storedHandles);
  }

  handlesToDisplay = handlesToDisplay.slice(0, this.limit);

  if (handlesToDisplay.length === 0) return;

  const products = await Promise.all(
    handlesToDisplay.map((handle) => this.fetchProduct(handle))
  );

  const validProducts = products.filter(Boolean);

  if (validProducts.length === 0) return;

  validProducts.forEach((product) => {
    this.grid.appendChild(this.createCard(product));
  });

  this.section.hidden = false;
}

  getStoredHandles() {
    try {
      const parsed = JSON.parse(
        window.localStorage.getItem(this.storageKey) || '[]'
      );

      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  saveCurrentProduct(existingHandles) {
    const updatedHandles = [
      this.currentHandle,
      ...existingHandles.filter(
        (handle) => handle !== this.currentHandle
      ),
    ].slice(0, 12);

    try {
      window.localStorage.setItem(
        this.storageKey,
        JSON.stringify(updatedHandles)
      );
    } catch (error) {
      // Local storage may be unavailable in some privacy modes.
    }
  }

  async fetchProduct(handle) {
    try {
      const root =
        window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}products/${encodeURIComponent(handle)}.js`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!response.ok) return null;

      return await response.json();
    } catch (error) {
      return null;
    }
  }

  createCard(product) {
    const article = document.createElement('article');
    article.className = 'ct-recently-viewed__card';

    const productUrl =
      `${window.Shopify?.routes?.root || '/'}products/${product.handle}`;

    const imageLink = document.createElement('a');
    imageLink.className = 'ct-recently-viewed__image-link';
    imageLink.href = productUrl;
    imageLink.setAttribute(
      'aria-label',
      product.title || 'View product'
    );

    if (product.featured_image) {
      const image = document.createElement('img');
      image.className = 'ct-recently-viewed__image';
      image.src = this.resizeImage(product.featured_image, 600);
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.width = 600;
      image.height = 600;
      imageLink.appendChild(image);
    }

    const title = document.createElement('a');
    title.className = 'ct-recently-viewed__title';
    title.href = productUrl;
    title.textContent = product.title || '';

    const price = document.createElement('div');
    price.className = 'ct-recently-viewed__price';

    const currentPrice = document.createElement('span');
    currentPrice.textContent = this.formatMoney(product.price);
    price.appendChild(currentPrice);

    if (
      product.compare_at_price &&
      product.compare_at_price > product.price
    ) {
      const comparePrice = document.createElement('span');
      comparePrice.className = 'ct-recently-viewed__compare';
      comparePrice.textContent = this.formatMoney(
        product.compare_at_price
      );
      price.appendChild(comparePrice);
    }

    article.appendChild(imageLink);
    article.appendChild(title);
    article.appendChild(price);

    return article;
  }

  resizeImage(source, width) {
    if (!source) return '';

    const separator = source.includes('?') ? '&' : '?';
    return `${source}${separator}width=${width}`;
  }

  formatMoney(cents) {
    const value = Number(cents || 0);

    const formatWithDelimiters = (
      amount,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) => {
      const number = (amount / 100).toFixed(precision);
      const parts = number.split('.');

      parts[0] = parts[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousands
      );

      return parts.length > 1
        ? `${parts[0]}${decimal}${parts[1]}`
        : parts[0];
    };

    let formattedValue;

    if (this.moneyFormat.includes('{{amount_no_decimals}}')) {
      formattedValue = formatWithDelimiters(value, 0);
      return this.moneyFormat.replace(
        '{{amount_no_decimals}}',
        formattedValue
      );
    }

    if (
      this.moneyFormat.includes(
        '{{amount_with_comma_separator}}'
      )
    ) {
      formattedValue = formatWithDelimiters(
        value,
        2,
        '.',
        ','
      );

      return this.moneyFormat.replace(
        '{{amount_with_comma_separator}}',
        formattedValue
      );
    }

    if (
      this.moneyFormat.includes(
        '{{amount_no_decimals_with_comma_separator}}'
      )
    ) {
      formattedValue = formatWithDelimiters(
        value,
        0,
        '.',
        ','
      );

      return this.moneyFormat.replace(
        '{{amount_no_decimals_with_comma_separator}}',
        formattedValue
      );
    }

    formattedValue = formatWithDelimiters(value);

    return this.moneyFormat.replace(
      '{{amount}}',
      formattedValue
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-ct-recently-viewed]')
    .forEach((section) => {
      new CTRecentlyViewed(section);
    });
});